import React from "react";
//import CMS from 'netlify-cms-app';
import InteractiveEditorInterface from "./InteractiveEditorInterface";
import { Interactive, deepMap, hydrate } from "./DataStructures";
import ErrorBoundary from "./ErrorBoundary";
import { setWWNDS } from "interactive";
import './NetlifyWidget.scss';
import InteractiveRenderer from "./InteractiveRenderer";

//CMS.init();
const DEBUG = true;
export function Preview({
  entry,
  value,
  onChange
}) {
  var _value;
  DEBUG && console.log("Preview entry", entry);
  if (value === undefined) {
    DEBUG && console.log("Preview value undefined");
    value = entry.getIn(["data", "interactive"]);
    DEBUG && console.log("Preview value", value);
  }
  DEBUG && console.log("Preview ToJS", value.toJS);
  let vJS = (_value = value) !== null && _value !== void 0 && _value.toJS ? value.toJS() : value;
  DEBUG && console.log("Preview vJS", vJS);
  if (vJS) {
    let i = new Interactive({
      ...vJS,
      panels: deepMap(vJS.panels, hydrate)
    });
    setWWNDS(i.wwnds);
    return /*#__PURE__*/React.createElement(InteractiveRenderer, {
      fullWidth: true,
      data: i
    });
  } else {
    return /*#__PURE__*/React.createElement("div", null, "Preview Failed to Load");
  }
}
function Widget({
  data,
  setData,
  onChange
}) {
  DEBUG && console.log("Widget render");
  return /*#__PURE__*/React.createElement(InteractiveEditorInterface, {
    noTitle: true,
    data: data,
    interactiveId: data.interactiveId,
    productId: data.productId,
    saveInteractive: () => {
      console.log("widget saveInteractive called");
    },
    isSaving: false,
    showSaveButton: false,
    onChanged: e => {
      DEBUG && console.log("Interactive onChanged", e);
      DEBUG && console.log("call this function?", onChange);
      let changed = {
        ...data,
        panels: deepMap(data.panels, item => {
          if (item.toJSON) {
            return item.toJSON();
          }
          return item;
        })
      };
      onChange(changed);
    }
  });
}
export default function NetlifyWidget({
  entry,
  value,
  onChange,
  ...props
}) {
  DEBUG && console.log("entry", entry);
  DEBUG && console.log("raw", entry.getIn(["raw"]));
  if (value === undefined) {
    console.log("value undefined");
    value = {};
  }
  DEBUG && console.log("ToJS", value.toJS);
  let vJS = value.toJS ? value.toJS() : value;
  DEBUG && console.log("vJS", vJS);
  let i = new Interactive({
    ...vJS,
    panels: deepMap(vJS.panels, hydrate)
  });
  setWWNDS(i.wwnds);
  const [data, setData] = React.useState(i);
  DEBUG && console.log("Entry", entry, "value", vJS, "onChange", onChange, "props", props);
  DEBUG && console.log("data", data);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Widget, {
    data: data,
    setData: setData,
    onChange: onChange
  }));
}

//CMS.registerWidget("ib", Template2)